import React from "react";
import {connect} from "react-redux";
import {Dialog, Button, Typography, TextField, InputLabel, Select, MenuItem, FormControl} from "@material-ui/core";
import {Delete, DeleteOutline} from '@material-ui/icons';
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import DateUtils from "@date-io/moment";
import {KeyboardDateTimePicker, MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers";
import axios from "axios";
import config from "../config.json";
import {partnerService} from "../services/PartnerService";
import {INotificacion} from "../types";


const tiposUsuario: Record<number, string> = {
    1: "Avanzado",
    2: "Profesional"
}

interface IProps {
    opened: boolean
    close(): void
    notify(notification: INotificacion): void
}

interface IState {
    promociones: Record<string, string|number>[]
    codigo: string | null
    fechaExpiracion: Date | null
    tipoUsuario: number | null
    superficie: number | null
    parcelas: number | null
    duracion: number | null
    precio: number | null
}

class CrearPromocion extends React.Component<IProps, IState>{

    state:IState = {
        promociones: [] as Record<string, string|number>[],
        codigo: null,
        fechaExpiracion: null,
        tipoUsuario: null,
        superficie: null,
        parcelas: null,
        duracion: null,
        precio: null
    }

    componentDidMount() {
        axios.get(config.url+'/promociones')
            .then((res) => {
                this.setState({promociones: res.data})
            })
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (!this.props.opened && nextProps.opened) this.componentDidMount()
        return true
    }

    okData = () : boolean => {
        if (this.state.codigo === null) return false
        if (this.state.fechaExpiracion === null) return false
        if (this.state.tipoUsuario === null) return false
        if (this.state.superficie === null) return false
        if (this.state.parcelas === null) return false
        if (this.state.duracion === null) return false
        if (this.state.precio === null) return false

        for (let promocion of this.state.promociones) {
            if (promocion["codigo"] === this.state.codigo) return false
        }

        return true
    }

    handleclick = () => {

        if (this.state.fechaExpiracion === null) return
        const data = {
            codigo: this.state.codigo,
            fecha_creacion: `${(new Date).getDate()}/${(new Date).getMonth()+1}/${(new Date).getFullYear()}`,
            fecha_expiracion: `${this.state.fechaExpiracion.getDate()}/${this.state.fechaExpiracion.getMonth() + 1}/${this.state.fechaExpiracion.getFullYear()}`,
            tipo_usuario: this.state.tipoUsuario,
            superficie: this.state.superficie,
            parcelas: this.state.parcelas,
            duracion: this.state.duracion,
            precio: this.state.precio
        }

        axios.post(
            config.url+'/create/promocion',
            data,
            {auth: {
                    username: `${partnerService.getUser()}`,
                    password: `${partnerService.getPass()}`
                }
            })
            .then((res) => {
                console.log(res.data)
                this.props.notify({message: "Promoción creada correctamente", variant: 'success'})
                this.props.close()
            })
            .catch(() => {
                this.props.notify({message: "Error interno", variant: 'error'})
            })

    }

    render() {
        return (
            <Dialog
                open={this.props.opened}
                onClose={() => this.props.close()}
                PaperProps={{
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        width: "fit-content",
                        maxHeight: '70vh',
                        height: "fit-content",
                    }
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <TextField
                    style={{
                        marginTop: 40,
                        marginLeft: 40,
                        marginRight: 40,
                        width: 250,
                        fontFamily: "Poppins"
                    }}
                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                    InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                    value={this.state.codigo}
                    onChange={e => this.setState({codigo: e.target.value})}
                    label={"Código de la promoción"}
                />


                <div
                    style={{
                        marginTop: 20,
                        marginLeft: 40,
                        marginRight: 40,
                        width: 250
                    }}
                >
                    <MuiPickersUtilsProvider
                        utils={DateUtils}
                    >
                        <KeyboardDatePicker
                            variant="inline"
                            label="Fecha expiración"
                            value={this.state.fechaExpiracion}
                            onChange={(f) => {
                                if (f !== null) {
                                    this.setState({fechaExpiracion: f.toDate()})
                                } else {
                                    this.setState({fechaExpiracion: null})
                                }
                            }}
                            format="YYYY/MM/DD"
                        />
                    </MuiPickersUtilsProvider>
                </div>

                <FormControl
                    style={{
                        marginTop: 20,
                        marginLeft: 40,
                        marginRight: 40,
                        width: 250
                    }}
                >
                    <InputLabel style={{fontSize: 16, fontFamily: "Poppins"}}>Tipo de Usuario</InputLabel>
                    <Select
                        style={{width: '100%', fontSize: 18, fontFamily: "Poppins"}}
                        value={this.state.tipoUsuario}
                        onChange={e => this.setState({tipoUsuario: e.target.value as number})}
                    >
                        {Object.keys(tiposUsuario).map(tipo =>
                            <MenuItem key={tipo} value={parseInt(tipo)}>
                                {tiposUsuario[parseInt(tipo)]}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>

                <TextField
                    style={{
                        marginTop: 20,
                        marginLeft: 40,
                        marginRight: 40,
                        width: 250
                    }}
                    type="number"
                    value={this.state.superficie}
                    placeholder={"Superficie (Ha)"}
                    label={"Superficie (Ha)"}
                    onChange={e => {
                        this.setState({superficie: parseInt(e.target.value)})
                    }}
                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                    InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                />

                <TextField
                    style={{
                        marginTop: 20,
                        marginLeft: 40,
                        marginRight: 40,
                        width: 250
                    }}
                    type="number"
                    value={this.state.parcelas}
                    placeholder={"#Parcelas"}
                    label={"#Parcelas"}
                    onChange={e => {
                        this.setState({parcelas: parseInt(e.target.value)})
                    }}
                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                    InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                />

                <TextField
                    style={{
                        marginTop: 20,
                        marginLeft: 40,
                        marginRight: 40,
                        width: 250
                    }}
                    type="number"
                    value={this.state.duracion}
                    placeholder={"Duración (meses)"}
                    label={"Duración (meses)"}
                    onChange={e => {
                        this.setState({duracion: parseInt(e.target.value)})
                    }}
                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                    InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                />

                <TextField
                    style={{
                        marginTop: 20,
                        marginLeft: 40,
                        marginRight: 40,
                        width: 250
                    }}
                    type="number"
                    value={this.state.precio}
                    placeholder={"Precio €"}
                    label={"Precio €"}
                    onChange={e => {
                        this.setState({precio: parseFloat(e.target.value)})
                    }}
                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                    InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                />

                <Button
                    style={{
                        margin: 40,
                        width: 250,
                        textTransform: "none"
                    }}
                    variant={"outlined"}
                    onClick={() => this.handleclick()}
                    disabled={!this.okData()}
                >
                    <Typography
                        style={{fontSize: 18, fontFamily: "Poppins"}}
                    >
                        Crear Promoción
                    </Typography>

                </Button>

            </Dialog>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    opened: state.navegacionPartners.dialogs.crea_promocion
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    close: () => dispatch({type: "open-new-promocion-dialog", callback: false}),
    notify: (notification: INotificacion) => dispatch({type: 'notify-partners', notification})
});

export default connect(mapStateToProps, mapDispatchToProps)(CrearPromocion);
